import { ProjectCodeSystemResponse } from "../../api-models/response/ProjectCodeSystemResponse";

export class ProjectCodeSystem implements ProjectCodeSystemResponse {
  id: string;
  name: string;
  language: string;
  readonly: boolean;

  constructor(projectCodeSystem: ProjectCodeSystemResponse, public isValid: boolean) {
    this.id = projectCodeSystem.id;
    this.name = projectCodeSystem.name;
    this.language = projectCodeSystem.language;
    this.readonly = projectCodeSystem.readonly;
  }
}
